import React from "react";
import { Twitter, Linkedin, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-24 bg-muted animate-pulse rounded-sm" />)}
      </div>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-background text-foreground border-t border-border/40">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559769/img/aiaffiliate_logo.png" alt="AIAffiliate Logo" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              Empowering tech-savvy professionals and entrepreneurs with expert-driven analysis and curated AI tool reviews for 2026.
            </p>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-semibold tracking-tight">Navigation</h3>
            <MenuProvider menu_id="45" className="w-full">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-semibold tracking-tight">Categories</h3>
            <ul className="flex flex-col gap-3">
              {[{
              label: "Content Creation",
              href: "/category/content"
            }, {
              label: "Video Generation",
              href: "/category/video"
            }, {
              label: "Marketing Automation",
              href: "/category/marketing"
            }, {
              label: "Productivity",
              href: "/category/productivity"
            }].map((category, i) => <li key={i} data-index={i}>
                  <Link to={category.href} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
                    {category.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="text-foreground font-semibold tracking-tight">Connect</h3>
            <div className="flex gap-4">
              {[{
              icon: Twitter,
              href: "https://twitter.com",
              label: "X (Twitter)"
            }, {
              icon: Linkedin,
              href: "https://linkedin.com",
              label: "LinkedIn"
            }, {
              icon: Youtube,
              href: "https://youtube.com",
              label: "YouTube"
            }].map((social, i) => <Link key={i} to={social.href} newTab className="group flex items-center justify-center w-10 h-10 rounded-full border border-border bg-card hover:bg-primary hover:border-primary transition-all duration-300" aria-label={social.label} data-index={i}>
                  <social.icon className="w-4 h-4 text-muted-foreground group-hover:text-primary-foreground transition-colors" />
                </Link>)}
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-border/40" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-muted-foreground/60">
          <div className="max-w-2xl text-center md:text-left">
            <p className="mb-2">
              <strong>Affiliate Disclosure:</strong> AIAffiliate participates in various affiliate marketing programs, which means we may get paid commissions on editorially chosen products purchased through our links to retailer sites.
            </p>
            <p>
              &copy; {currentYear} AIAffiliate. All rights reserved.
            </p>
          </div>
          
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-foreground transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>;
}